import { format } from 'date-fns';

const DAY_IN_MS = 24 * 60 * 60 * 1000;

/**
 * Date calendaire d'une période de tarif stockée en base.
 *
 * Le sélecteur de dates produit minuit dans le fuseau de la personne qui
 * saisit, puis la base le stocke en UTC : le 31/10 saisi à Paris vaut
 * `…T23:00Z`, saisi à New York `…T04:00Z`. En arrondissant au minuit UTC le
 * plus proche on retrouve le même jour calendaire, quel que soit le fuseau de
 * saisie (de UTC-12 à UTC+11) et celui de la personne qui consulte.
 *
 * Renvoie minuit, heure locale, de ce jour calendaire.
 */
export const storedDateToLocalDate = (value: Date | string): Date => {
  const instant = new Date(value).getTime();
  const utcMidnight = new Date(Math.round(instant / DAY_IN_MS) * DAY_IN_MS);
  return new Date(
    utcMidnight.getUTCFullYear(),
    utcMidnight.getUTCMonth(),
    utcMidnight.getUTCDate(),
  );
};

/**
 * Clé d'un jour dans les tables de prix. Elle ne dépend que du jour
 * calendaire, pas du fuseau ni de l'heure d'été (contrairement à
 * `toISOString()`).
 */
export const priceDateKey = (date: Date): string => format(date, 'yyyy-MM-dd');

/** Inverse de `priceDateKey` : minuit local du jour désigné par la clé. */
export const priceKeyToDate = (key: string): Date => {
  const [year, month, day] = key.split('-').map(Number);
  return new Date(year, month - 1, day);
};
